import {Component, OnInit, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { CustomerManager } from 'src/app/data/manager/customer/customer/customer.manager';
import {SessionEvent} from '../../event-listeners/session/session.event';
import { ToastEvent } from '../../event-listeners/toast/toast.event';
import { UpdateCreatePasswordModalEvent } from '../../event-listeners/update-create-password-modal/update-create-password-modal.event';
import {UpdateSessionModalEvent} from '../../event-listeners/update-session-modal/update-session-modal.event';
import { SupportManager } from 'src/app/data/manager/support/support.manager';

declare const FB: any;
@Component({
  selector: 'app-session-forms',
  templateUrl: './session-forms.component.html',
  styleUrls: ['./session-forms.component.scss'],
})


export class SessionFormsComponent implements OnInit, OnChanges, OnChanges {
  @Input() isModal = false;
  @Input() isModalStyle = false;
  @Input() modalStatus;
  @Input() isRegister = false;
  @Output() signUpActive = new EventEmitter();
  @Input() isBanner : boolean = false;
  idPrefix = '';
  isSignUpActive = false;
  resetMode = false;
  selectMethodMode = false;
  validateCodeMode = false;
  selectEmailMode = false;
  openResetModal = {open: false};
  openSelectMethodMessageModal = {open: false}
  customerData;
  showTitle: boolean = true;
  emailError: any;
  public isFromStore: boolean = false;

  set setSignUpActive(active) {
    this.isSignUpActive = active;
  }

  get getSignUpActive() {
    return this.isSignUpActive;
  }

  constructor(private router: Router,
              private loginEvent: SessionEvent,
              private sessionModalStatusEvent: UpdateSessionModalEvent,
              private createPasswordModalEvent: UpdateCreatePasswordModalEvent,
              private customerManager: CustomerManager,
              private activatedRoute: ActivatedRoute,
              private supportManager: SupportManager,
              private toastEvent: ToastEvent) {
                this.activatedRoute.queryParams
                  .subscribe( params =>{
                    if(params && params?.store){
                      this.isFromStore = true;
                      this.setSignUpActive = true;
                    }
                    if(params && params?.singUp){
                      this.setSignUpActive = true;
                    }
                });
               }

  onSuccess(event, typeForm?) {
    const id = (event?.id || event?.customerOldId);
    if ((typeof event === 'boolean' && event) || id > 0) {
      if (this.isModal) {
        this.sessionModalStatusEvent.changeModalStatus({close: true});
        this.createPasswordModalEvent.changeModalStatus({open: true, close: false});
      } else {
        if(this.isFromStore){
          this.setSignUpActive = true;
          this.customerManager.logOut().subscribe();
          this.toastEvent.updateToast({success: true, message: 'Usuario creado satisfactoriamente'});
        }else{
          if(typeForm === 'signUp'){
            this.toastEvent.updateToast({success: true, message: 'Usuario creado satisfactoriamente'});
          }
          this.router.navigate(['/']);
        }
      }
      if (event.id && event.id > 0) {
        this.loginEvent.changeLoginStatus(event);
      }
      this.loadKustomerToken();
    }
  }

  loadKustomerToken(){
    if(this.supportManager.isKustomerChatActive()) {
      this.supportManager.getUserToken();
    }
  } 

  onOpenLogin() {
    this.isSignUpActive = false;
    this.signUpActive.emit(this.getSignUpActive);
  }

  onOpenSignUp() {
    this.isSignUpActive = true;
    this.signUpActive.emit(this.getSignUpActive);
  }

  onResetPasswordMode(event) {
    this.resetMode = event;
  }

  onSelectMethodMessageMode(event) {
    this.selectMethodMode = event;
  }

  onValidateCodeMode(event) {
    this.validateCodeMode = event;
    if (this.validateCodeMode) {
      this.selectMethodMode = false;
    }
  }

  onSelectEmailMode(event) {
    this.selectEmailMode = event;
    if (this.selectEmailMode) {
      this.selectMethodMode = false;
    }
  }

  onOpenResetPassword() {
    if (!this.isModal) {
      this.openResetModal = {open: true};
    }
  }

  onOpenSelectMethodMessage() {
    if (!this.isModal) {
      this.openSelectMethodMessageModal = {open: true};
    }
  }

  onUserNotFound(event) {
    setTimeout(() => {
      this.setSignUpActive = true;
      this.customerData = event;
    }, 10);
  }

  initFbScript() {
    const fbKey = '1783292855316938';
    const fbApiV = 'v8.0';
    (() => {
      const d = document;
      const fbJs = d.createElement('script');
      const id = 'facebook-jssdk';
      const ref = d.getElementsByTagName('script')[0];
      fbJs.id = id;
      fbJs.async = true;
      fbJs.defer = true;
      fbJs.src = '//connect.facebook.net/en_US/sdk.js';

      fbJs.onload = () => {
        FB.init({
          appId: fbKey,
          status: true,
          cookie: true,
          xfbml: true,
          version: fbApiV,
        });
      };

      ref.parentNode.insertBefore(fbJs, ref);
    })();
  }

  ngOnInit() {
    this.initFbScript();
    if (!this.isModal) {
      this.idPrefix = 'session-';
    }
  }

  ngOnChanges(): void {
    if (this.isModal && this.modalStatus && this.modalStatus.open) {
      this.isSignUpActive = false;
    }
  }

  errorEmailTitle(event){
    this.showTitle = event.showTitle;
  }

  emailErrorRegister(event){
    this.isSignUpActive = false;
    this.emailError = event;
  }
}
